export const editableCellsConfig = {
  vo_valeur_theorique: {
    label: "Valeur théorique VO HT",
    title: "Valeur théorique VO HT",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 1,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_prix_vente: {
    label: "Prix de vente",
    title: "Prix de vente",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 2,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_prix_vente_propose: {
    label: "Prix de vente proposé TTC",
    title: "Prix de vente proposé TTC",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 3,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_prix_vente_facture: {
    label: "Prix de vente facturé HT",
    title: "Prix de vente facturé HT",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 4,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_prix_vente_definitif: {
    label: "Prix de vente définitif TTC",
    title: "Prix de vente définitif TTC",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 5,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_prospect: {
    label: "Prospect",
    title: "Prospect",
    type: "text",
    order: 6,
  },
  vo_date_facture: {
    label: "Date facture",
    title: "Date facture",
    type: "date",
    order: 7,
    formatter: (value) => new Date(value).toLocaleDateString("fr-FR"),
  },
  vo_date_vo: {
    label: "Date VO",
    title: "Date VO",
    type: "date",
    order: 8,
    formatter: (value) => new Date(value).toLocaleDateString("fr-FR"),
  },
  vo_client_facture: {
    label: "Client facture",
    title: "Client facture",
    type: "text",
    order: 9,
  },
  vo_cout_rme_facture: {
    label: "Coût RME facturé",
    title: "Coût RME facturé",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 10,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
  vo_commission: {
    label: "Commission TTC",
    title: "Commission TTC",
    type: "number",
    props: { min: 0, step: 0.01 },
    order: 11,
    formatter: (value) => `${Number(value).toFixed(2)} €`, //must be truncated to 2 decimals
  },
};
